import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateListingRoutingModule } from './create-listing-routing.module';
import { CreateListingPageComponent } from './components/page/create-listing-page.component';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from '../shared/shared.module';
import { Angulartics2Module } from 'angulartics2';
import { MatDialogModule } from '@angular/material/dialog';
import { ImageListEditorModule } from '../shared/image-list-editor/image-list-editor.module';

@NgModule({
  declarations: [
	  CreateListingPageComponent,
  ],
  imports: [
    CommonModule,
    CreateListingRoutingModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatCardModule,
    SharedModule,
    Angulartics2Module,
    MatDialogModule,
    ImageListEditorModule
  ],
})
export class CreateListingModule { }
